import { Component, Input } from '@angular/core';
import { MusicChannel } from '@model/musicChannel';
import { MusicCollection } from '@model/musicCollection';
import { AppV5StateService } from '@service/app-v5/app-v5-state.service';

@Component({
    selector: 'tun-search-music-channel-large-view',
    templateUrl: './search-music-channel-large-view.component.html',
    styleUrl: './search-music-channel-large-view.component.scss',
    standalone: false
})
export class SearchMusicChannelLargeViewComponent {

  @Input() searchMusicChannel: MusicChannel;

  @Input() hexColor: string = "#F6836A";

  get name(){
    return this.searchMusicChannel.name;
  }

  get musicCollections(){
    return this.searchMusicChannel.musicCollections;
  }

  get horizontalLineBackground(){
    return 'linear-gradient(0.25turn, {0}, rgb(34, 181, 128, 0))'.replace('{0}', this.hexColor);
  }

  constructor(
    private appV5StateService:AppV5StateService
  ){

  }

  public onShowDetails(musicCollection: MusicCollection){
    this.appV5StateService.showSearchMusicChannelInTunifyOrange(this.searchMusicChannel);
    this.appV5StateService.showSearchMusicCollectionInTunifyOrange(musicCollection);
  }
}
